module.exports = __webpack_public_path__ + "img/filter-icon.44ae27e5.svg";